import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { fetchProperksChallenge, cancelProperksChallenge, relaunchProperksChallenge } from '../../../../actions/metricsAction';
import { createLoadingSelector } from '../../../../apis/selectors';
import { challengeStatusFilter } from '../utils';

const actions = ['GET_PROPERKS_CHALLENGE'];
const loadingSelector = createLoadingSelector(actions);
export const ROWS_PER_PAGE = 20;

export const useChallengeList = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState(challengeStatusFilter.all);
  const statusForApi =  status === challengeStatusFilter.all ? undefined : status;

  const { data, totalElements: total } = useSelector(
    (state) => state.metrics.properksChallenges,
  );
  const totalPages = Math.ceil(total / ROWS_PER_PAGE);

  const isLoading = useSelector((state) => loadingSelector(state));

  const fetchData = useCallback(() => {
    dispatch(
      fetchProperksChallenge({
        limit: ROWS_PER_PAGE,
        status: statusForApi,
        page: 1
      }),
    );
  }, [dispatch, statusForApi]);

  useEffect(() => {
    fetchData()
  }, [fetchData, statusForApi])

  const handleTableChange = (pageTarget) => {
    setPage(pageTarget);
    dispatch(
      fetchProperksChallenge({
        limit: ROWS_PER_PAGE,
        status: statusForApi,
        page: pageTarget
      }),
    );
  };

  const handleCancel = (id) => {
    dispatch(
      cancelProperksChallenge(id),
    );
  }

  const handleRelaunch = (payload) => {
    dispatch(
      relaunchProperksChallenge(payload),
    );
    const page = document.getElementById('properks-page');
    page?.scrollTo({ top: 0, behavior: 'smooth' });
  }


  return {
    data,
    page,
    total,
    totalPages,
    isLoading,
    fetchData,
    handleTableChange,
    status,
    setStatus,
    handleRelaunch,
    handleCancel,
  };
};
